import { SVGProps } from '@components/Icon/types';

export const Briefcase = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 5.66211C20.9328 5.66211 22.0879 6.81716 22.0879 8.25V19.5C22.0879 20.9328 20.9328 22.0879 19.5 22.0879H4.5C3.06716 22.0879 1.91211 20.9328 1.91211 19.5V8.25C1.91211 6.81716 3.06716 5.66211 4.5 5.66211H19.5ZM20.6621 12.6475C18.2913 13.8673 15.7332 14.5598 13.1504 14.7188V15.5C13.1504 16.1351 12.6351 16.6504 12 16.6504C11.3649 16.6504 10.8496 16.1351 10.8496 15.5V14.7188C8.26676 14.5598 5.70866 13.8673 3.33789 12.6475V19.5C3.33789 20.1484 3.85159 20.6621 4.5 20.6621H19.5C20.1484 20.6621 20.6621 20.1484 20.6621 19.5V12.6475ZM4.5 7.08789C3.85159 7.08789 3.33789 7.60159 3.33789 8.25V11.0303C8.70937 14.0964 15.2906 14.0964 20.6621 11.0303V8.25C20.6621 7.60159 20.1484 7.08789 19.5 7.08789H4.5Z"
      fill={fill}
    />
    <path
      d="M13.5 1.91211C14.9328 1.91211 16.0879 3.06716 16.0879 4.5C16.0879 4.90159 15.7766 5.21289 15.375 5.21289C14.9734 5.21289 14.6621 4.90159 14.6621 4.5C14.6621 3.85159 14.1484 3.33789 13.5 3.33789H10.5C9.85159 3.33789 9.33789 3.85159 9.33789 4.5C9.33789 4.90159 9.02659 5.21289 8.625 5.21289C8.22341 5.21289 7.91211 4.90159 7.91211 4.5C7.91211 3.06716 9.06716 1.91211 10.5 1.91211H13.5Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'briefcase';
